// extracted by mini-css-extract-plugin
export default {"softwareContainer":"device-group-table_softwareContainer__yq4bE"};